// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-27d1e88d],.fade-leave-active[data-v-27d1e88d]{transition:opacity 0.3s}.fade-enter[data-v-27d1e88d],.fade-leave-to[data-v-27d1e88d]{opacity:0}.layout__row[data-v-27d1e88d]{min-height:100vh !important}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
